import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PlayFeed from './PlayFeed';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import playFeed from './playFeed/store/reducers/playFeed';
import { getPlayFeedState } from './playFeed/store/selectors/getPlayFeedState';

initContainerData.register({
    reducers: { playFeed }
});

const PlayFeedDataContainer = (props) => {
    const {
        playsByInning
    } = useSelector(getPlayFeedState);

    return (
        <PlayFeed
            { ...props }
            playsByInning={ playsByInning }
        />
    );
};

PlayFeedDataContainer.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    reverseChron: PropTypes.bool
};

export default PlayFeedDataContainer;
